import Style from "./style"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import { useRef } from "react";
import useGetStoreTicketTypes from "entity/store/useGetStoreTicketTypes";
import usePostPaymentCollect from "entity/franchise/usePostPaymentCollect";
import arrowDownIcon from 'shared/assets/ic_arrow_down.svg'

const PaymentCollectionModal = ({ managerId, closeEvent }) => {
    const numberRef = useRef();
    const voucherTypeRef = useRef()

    const [ticketTypesList] = useGetStoreTicketTypes()
    const [paymentTicket, collectTicket] = usePostPaymentCollect(managerId, numberRef, voucherTypeRef, closeEvent)

    const voucherTypeOptions = [
        { value: 'all', label: '== 모든 유형 ==' },
        ...(ticketTypesList?.data?.ticket_types || [])
            .sort((a, b) => a.idx - b.idx)
            .map(voucher => ({
                value: voucher.idx,
                label: voucher.name
            }))
    ]

    return (
        <DefaultModal
            title={"지불 및 수금"}
            closeEvent={closeEvent}
        >
            <Style.Wrapper>
                <Style.SelectWrapper>
                    <select ref={voucherTypeRef} >
                        {voucherTypeOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <img src={arrowDownIcon} alt='arrow' />
                </Style.SelectWrapper>
                <Style.GiveDiv>
                    <input 
                        placeholder="개수 입력" 
                        ref={numberRef} 
                        type="number"
                        min="0"
                    />
                    <DefaultButton small fitWidth expandHeight clickEvent={paymentTicket}>
                        지불
                    </DefaultButton>
                    <DefaultButton
                        small
                        fitWidth
                        expandHeight
                        clickEvent={collectTicket}
                    >
                        수집
                    </DefaultButton>
                </Style.GiveDiv>
                
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default PaymentCollectionModal